<script lang="ts">
    import ArrowLeft from "$lib/assets/ArrowLeft.svg";
    import ArrowRight from "$lib/assets/ArrowRight.svg";
    import ArrowsDownUp from "$lib/assets/ArrowsDownUp.svg";
    import Funnel from "$lib/assets/FunnelSimple.svg";
    import MagnifyingGlass from "$lib/assets/MagnifyingGlass.svg";
    import PaperPlaneRight from "$lib/assets/PaperPlaneRight.svg";

    import GrantBookmark from "$lib/components/GrantBookmark.svelte";
    import GrantCard from "$lib/components/GrantCard.svelte";
    import GrantSearchLoadingItem from "$lib/components/GrantSearchLoadingItem.svelte";
    import SearchFilter from "$lib/components/SearchFilter.svelte";

    import * as Sentry from "@sentry/sveltekit";

    import { onMount } from "svelte";

    import { getModalStore, type ModalSettings } from "@skeletonlabs/skeleton";

    const modalStore = getModalStore();

    export let data;
    let { session, user, session_id } = data;
    $: ({ session, user, session_id } = data);

    let do_search: boolean = false;
    var flipped: boolean = false;
    var sortType: string = "Search Relevance";
    $: itemList = [];
    $: display_grant_cards = false;
    $: search_title = "Suggested Grants";
    $: search_bar_content = null;
    $: require_login_for_search = false;
    $: page_num = 0;
    $: filters = {
        close_date_filters: {
            Start: null,
            End: null,
        },
        award_ceiling_filters: {
            Minimum: null,
            Maximum: null,
        },
        agency_filters: {
            "Department of Agriculture": true,
            "Department of Commerce": true,
            "Department of Defense": true,
            "Department of Education": true,
            "Department of Energy": true,
            "Department of Health and Human Services": true,
            "Department of Housing and Urban Development": true,
            "Department of Justice": true,
            "Department of Labor": true,
            "Department of State": true,
            "Department of the Interior": true,
            "Department of Transportation": true,
            "Department of Veterans Affairs": true,
            "Government of California": true,
            "Government of Florida": true,
            "National Aeronautics and Space Administration": true,
            "National Science Foundation": true,
        },
        status_filters: {
            Open: true,
            Closed: false,
        },
        funding_type_filters: {
            Grant: true,
            Contract: false,
        },
    };

    $: all_agency_filters_selected = !Object.values(filters.agency_filters).includes(false);
    $: all_status_filters_selected = !Object.values(filters.status_filters).includes(false);
    $: all_funding_type_filters_selected = !Object.values(filters.funding_type_filters).includes(false);

    function signIn(): void {
        const modal: ModalSettings = {
            type: "component",
            component: "signIn",
            meta: {
                data: data,
            },
        };
        modalStore.trigger(modal);
    }

    function scrollTop(): void {
        const el = document.getElementById("search-bar");
        el!.scrollIntoView({ behavior: "smooth" });
    }

    async function display_grants(find_bookmarks: boolean = true): Promise<void> {
        display_grant_cards = false;
        let user_bookmarks = {};
        if (session && find_bookmarks) {
            let bookmark_resp: Response = await fetch(
                `/api/grantrec/get_bookmark?` + new URLSearchParams({ user_id: session?.user.id }),
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                },
            );
            let bookmark_result = await bookmark_resp.json();
            if (bookmark_result.results) {
                for (var i of bookmark_result.results) {
                    user_bookmarks[i[0]] = true;
                }
            }
            for (var item of itemList) {
                if (user_bookmarks[item.props.grantId]) {
                    item.props.bookmarked = true;
                } else {
                    item.props.bookmarked = false;
                }
            }
        }

        switch (sortType) {
            case "Search Relevance":
                itemList.sort((a, b) => {
                    if (a.score == b.score) {
                        return a.props.grantId < b.props.grantId ? 1 : -1;
                    }
                    return a.score < b.score ? 1 : -1;
                });
                break;
            case "Award Ceiling":
                itemList.sort((a, b) => {
                    if (a.ceiling == b.ceiling) {
                        return a.props.grantId < b.props.grantId ? 1 : -1;
                    }
                    return a.ceiling < b.ceiling ? 1 : -1;
                });
                break;
            case "Due Date":
                itemList.sort((a, b) => {
                    if (Date.parse(a.due_date) == Date.parse(b.due_date)) {
                        return a.props.grantId < b.props.grantId ? 1 : -1;
                    }
                    return Date.parse(a.due_date) < Date.parse(b.due_date) ? 1 : -1;
                });
                break;
        }
        if (flipped) itemList.reverse();

        itemList = itemList;
        page_num = 0;
        display_grant_cards = true;
    }

    async function search(search_query): Promise<void> {
        display_grant_cards = false;
        if (session && session?.user?.id && session?.user?.email) {
            Sentry.setUser({ id: session.user.id, email: session.user.email });
        }

        itemList = [];

        let is_suggested: boolean = false;
        let user_search: boolean = true;

        if (!search_query || search_query == "") {
            search_query = "Open Grant";
            is_suggested = true;
            user_search = false;
        } else {
            search_query = search_query.replace(/[\u{0080}-\u{FFFF}]/gu, "");
        }

        search_title = "Loading...";

        if (!user && search_query && require_login_for_search) {
            search_title = "Please log in to search.";
            signIn();
        } else {
            if (search_query) {
                require_login_for_search = true;
                document.cookie = "requireLoginForSearch=true";
            }
            await Promise.all([
                fetch(`/api/grantrec/search`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        user_id: session?.user.id,
                        session_id: session_id,
                        query: search_query,
                        filters: filters,
                    }),
                }).then((resp) => {
                    if (resp.ok) {
                        return resp.json();
                    } else if (resp.status == 404) {
                        search_title = "No Results";
                        return { results: [] };
                    } else throw new Error(resp.status);
                }),
                fetch(`/api/grantrec/search_match`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ user_id: session?.user.id, query: search_query, filters: filters }),
                }).then((resp) => {
                    if (resp.ok) {
                        return resp.json();
                    } else throw new Error(resp.status);
                }),
                fetch(`/api/grantrec/log`, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        user_id: session?.user.id,
                        session_id: session_id,
                        action: "search",
                        query: user_search ? search_query : "",
                        filters: filters,
                    }),
                }),
            ]).then(async ([result_query, result_match_query]) => {
                let already_shown = [];
                if (result_match_query.success) {
                    for (var i = 0; i < result_match_query.results.length; i++) {
                        let grant: any = result_match_query.results[i];

                        already_shown.push(grant.GrantID);

                        itemList.push({
                            props: {
                                grantId: grant.GrantID,
                                grantTitle: grant.Title,
                                agency: grant.Agency,
                                branch: grant.Branch,
                                dueDate: grant.CloseDate,
                                bookmarked: grant.Bookmarked ?? false,
                                awardMoney: grant.AwardCeiling,
                                phase: grant.Phase,
                                doLoad: false,
                                summary: grant.SummaryShort,
                                verified: grant.Verified,
                            },
                            score: 1.0,
                            ceiling: grant.AwardCeiling ?? 0,
                            due_date: grant.CloseDate,
                        });
                    }
                }

                for (var i = 0; i < result_query.results?.length ?? 0; i++) {
                    let grant: any = result_query.results[i];

                    if (already_shown.includes(grant.GrantID)) continue;

                    itemList.push({
                        props: {
                            grantId: grant.GrantID,
                            grantTitle: grant.Title,
                            agency: grant.Agency,
                            branch: grant.Branch,
                            dueDate: grant.CloseDate,
                            bookmarked: grant.Bookmarked ?? false,
                            awardMoney: grant.AwardCeiling,
                            phase: grant.Phase,
                            doLoad: false,
                            summary: grant.SummaryShort,
                            verified: grant.Verified,
                        },
                        score: grant.Score,
                        ceiling: grant.AwardCeiling ?? 0,
                        due_date: grant.CloseDate,
                    });
                }

                if (is_suggested) {
                    if (session) {
                        search_title = "Suggested Grants";
                    } else {
                        search_title = "Browse Grants";
                    }
                } else {
                    search_title = "Search Results";
                }

                await display_grants(false);
            });
        }

        display_grant_cards = true;
    }

    onMount(() => {
        require_login_for_search = ("; " + document.cookie).split(`; requireLoginForSearch=`).pop().split(";")[0];
        search();
    });
</script>

<svelte:head>
    <title>Arwin</title>
</svelte:head>

<div id="search-bar" class="overflow-auto bg-zinc-800 xs:m-2 p-4 rounded-lg shadow-md box-border">
    <form on:submit={search(search_bar_content)} accept-charset="utf-8">
        <div id="search-bar-row" class="flex h-7">
            <img src={MagnifyingGlass} class="size-7" alt="Magnifying Glass" />
            <input
                id="search-input"
                class="bg-transparent border-none outline-none outline-0 shadow-none flex-auto text-white selection:bg-stone-200 selection:bg-opacity-40"
                type="text"
                placeholder="Search grants..."
                bind:value={search_bar_content}
            />
            <button
                id="submit-button"
                class="bg-neutral-700 opacity-100 shrink-0 size-7 rounded text-center flex justify-center items-center"
            >
                <img src={PaperPlaneRight} class="size-7" alt="Right Paper Plane" />
            </button>
        </div>
    </form>
    <hr class="!border-stone-400 h-0.5 my-3" />
    <p class="text-stone-400 text-xs">
        Describe your business (e.g. "Grant writing tool"), or search by grant name or grant ID.
        <br /> Don't see your grant here?
        <a href="mailto:founders@getarwin.com" class="text-blue-300">Let us know.</a>
    </p>
</div>

<div id="filters" class="mt-6 xs:m-2 flex items-center justify-left relative z-40 gap-1">
    <img src={Funnel} alt="Funnel" />
    <p class="ml-1">Filter By</p>

    <SearchFilter
        name="Due Date"
        bind:value={filters.close_date_filters}
        search_func={() => search(search_bar_content)}
        bind:do_search
    >
        <p class="font-bold text-base mb-1">Due Date</p>
        {#each Object.keys(filters.close_date_filters) as filter}
            {@const is_selected = !(filters.close_date_filters[filter] == null)}
            <span class="flex items-center w-[200px] my-2">
                <input
                    id="Toggle close date {filter}"
                    type="checkbox"
                    checked={is_selected}
                    on:click|stopPropagation={(event) => {
                        if (!event.target.checked) {
                            filters.close_date_filters[filter] = null;
                        } else {
                            filters.close_date_filters[filter] = new Date().toISOString().slice(0, 10);
                        }
                    }}
                />
                <label for="Toggle close date {filter}">
                    <p class="ml-2">{filter}</p>
                </label>
                {#if filters.close_date_filters[filter] != null}
                    <input
                        type="date"
                        class="ml-auto rounded-lg px-2 py-1 text-sm w-[120px] h-[28px] border border-solid border-zinc-800"
                        value={filters.close_date_filters[filter]}
                        on:change|stopPropagation={(event) => {
                            filters.close_date_filters[filter] =
                                event.target.value ?? new Date().toISOString().slice(0, 10);
                        }}
                    />
                {:else}
                    <label for="Toggle close date {filter}" class="ml-auto">
                        <p
                            class="rounded-lg px-2 py-1 bg-secondary-500 text-sm w-[120px] h-[28px] border border-solid border-zinc-800"
                        >
                            None
                        </p>
                    </label>
                {/if}
            </span>
        {/each}
    </SearchFilter>

    <SearchFilter
        name="Award Ceiling"
        bind:value={filters.award_ceiling_filters}
        search_func={() => search(search_bar_content)}
        bind:do_search
    >
        <p class="font-bold text-base mb-1">Award Ceiling</p>
        {#each Object.keys(filters.award_ceiling_filters) as filter}
            {@const is_selected = !(filters.award_ceiling_filters[filter] == null)}
            <span class="flex items-center w-[240px] my-2">
                <input
                    id="Toggle award ceiling {filter}"
                    type="checkbox"
                    checked={is_selected}
                    on:click={(event) => {
                        if (!event.target.checked) {
                            filters.award_ceiling_filters[filter] = null;
                        } else {
                            filters.award_ceiling_filters[filter] = 0;
                        }
                    }}
                />
                <label for="Toggle award ceiling {filter}">
                    <p class="ml-2">Set {filter}</p>
                </label>
                {#if filters.award_ceiling_filters[filter] != null}
                    <input
                        type="number"
                        class="ml-auto rounded-lg px-2 py-1 text-sm w-[100px] h-[28px] border border-solid border-zinc-800"
                        value={filters.award_ceiling_filters[filter]}
                        step="1000"
                        min="0"
                        oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : 0"
                        on:change={(event) => {
                            filters.award_ceiling_filters[filter] = event.target.value ?? "0";
                        }}
                    />
                {:else}
                    <label for="Toggle award ceiling {filter}" class="ml-auto">
                        <p
                            class="rounded-lg px-2 py-1 bg-secondary-500 text-sm w-[100px] h-[28px] border border-solid border-zinc-800"
                        >
                            None
                        </p>
                    </label>
                {/if}
            </span>
        {/each}
    </SearchFilter>

    <SearchFilter
        name="Status"
        bind:value={filters.status_filters}
        search_func={() => search(search_bar_content)}
        bind:do_search
    >
        <span class="flex items-center">
            <p class="font-bold text-base mb-1 mr-2">Status</p>
            <input
                id="toggle-all-status-filters"
                type="checkbox"
                class="ml-auto"
                bind:checked={all_status_filters_selected}
                on:click={(event) => {
                    for (var key in filters.status_filters) {
                        filters.status_filters[key] = event.target.checked;
                    }
                }}
            />
            <label for="toggle-all-status-filters">
                <p class="ml-2">Select All</p>
            </label>
        </span>
        {#each Object.keys(filters.status_filters) as filter}
            <span class="flex items-center my-1">
                <input type="checkbox" bind:checked={filters.status_filters[filter]} id="Toggle status {filter}" />
                <label for="Toggle status {filter}">
                    <p class="ml-2">{filter}</p>
                </label>
            </span>
        {/each}
    </SearchFilter>

    <SearchFilter
        name="Agency"
        bind:value={filters.agency_filters}
        search_func={() => search(search_bar_content)}
        bind:do_search
    >
        <span class="flex items-center">
            <p class="font-bold text-base mb-1">Agency</p>
            <input
                id="toggle-all-agency-filters"
                type="checkbox"
                class="ml-auto"
                bind:checked={all_agency_filters_selected}
                on:click={(event) => {
                    for (var key in filters.agency_filters) {
                        filters.agency_filters[key] = event.target.checked;
                    }
                }}
            />
            <label for="toggle-all-agency-filters">
                <p class="ml-2">Select All</p>
            </label>
        </span>
        {#each Object.keys(filters.agency_filters) as filter}
            <span class="flex items-center my-1">
                <input type="checkbox" bind:checked={filters.agency_filters[filter]} id="Toggle agency {filter}" />
                <label for="Toggle agency {filter}">
                    <p class="ml-2">{filter}</p>
                </label>
            </span>
        {/each}
    </SearchFilter>

    <SearchFilter
        name="Funding Type"
        bind:value={filters.funding_type_filters}
        search_func={() => search(search_bar_content)}
        bind:do_search
    >
        <span class="flex items-center">
            <p class="font-bold text-base mb-1 mr-3">Funding Type</p>
            <input
                id="toggle-all-funding-type-filters"
                type="checkbox"
                class="ml-auto"
                bind:checked={all_funding_type_filters_selected}
                on:click={(event) => {
                    for (var key in filters.funding_type_filters) {
                        filters.funding_type_filters[key] = event.target.checked;
                    }
                }}
            />
            <label for="toggle-all-funding-type-filters">
                <p class="ml-2">Select All</p>
            </label>
        </span>
        {#each Object.keys(filters.funding_type_filters) as filter}
            <span class="flex items-center my-1">
                <input
                    type="checkbox"
                    bind:checked={filters.funding_type_filters[filter]}
                    id="Toggle funding type {filter}"
                />
                <label for="Toggle funding type {filter}">
                    <p class="ml-2">{filter}</p>
                </label>
            </span>
        {/each}
    </SearchFilter>
</div>

<div id="grants-section" class="mt-6 xs:m-2 bg-transparent">
    <span id="grants-section-header" class="flex justify-between xs:px-3.5">
        <p id="search-result-title" class="font-semibold">{search_title}</p>
        <span class="flex">
            <div class="relative size-5">
                <input
                    type="checkbox"
                    id="do_reverse"
                    class="absolute top-0 left-0 opacity-0 z-auto"
                    bind:checked={flipped}
                    on:change={display_grants}
                />
                <label for="do_reverse" class="w-full h-full cursor-pointer">
                    <img
                        src={ArrowsDownUp}
                        alt="ArrowsDownUp"
                        class="absolute top-0.5 right-0.5 w-full h-full object-cover rounded-lg transition duration-300 hover:bg-secondary-600"
                    />
                </label>
            </div>
            <form class="flex" on:change={display_grants}>
                <label for="sort-option" class="mr-1">Sort By:</label>
                <select
                    name="sort-option"
                    id="sort-options"
                    class="rounded-lg py-0 pl-1 pr-6 text-sm box-border"
                    bind:value={sortType}
                >
                    <option value="Search Relevance">Relevance</option>
                    <option value="Award Ceiling">Award Ceiling</option>
                    <option value="Due Date">Due Date</option>
                </select>
            </form>
        </span>
    </span>

    <div class="grid grid-cols-[min-content_1fr] xs:mt-1 mt-3 gap-2">
        <div class="grid grid-cols-subgrid col-span-7">
            <p class="xs:hidden col-start-2 text-zinc-500 text-xs text-left">Grant Name, ID, Phase, Agency</p>
            <p class="xs:hidden col-start-3 xs:row-start-1 text-zinc-500 text-xs text-center">Due Date</p>
            <p class="xs:hidden col-start-4 xs:col-start-3 text-zinc-500 text-xs text-center">Award Ceiling</p>
        </div>

        <div class="grid grid-cols-subgrid col-span-7">
            {#if display_grant_cards}
                {#each { length: 10 } as _, i}
                    {@const idx = page_num * 10 + i}
                    {#if idx < itemList.length}
                        <div class="col-span-full mb-8">
                            <GrantCard
                                doLoad={false}
                                user_id={session?.user.id}
                                {session_id}
                                grantId={itemList[idx].props.grantId}
                                phase={itemList[idx].props.phase}
                                grantTitle={itemList[idx].props.grantTitle}
                                agency={itemList[idx].props.agency}
                                branch={itemList[idx].props.branch}
                                dueDate={itemList[idx].props.dueDate}
                                awardMoney={itemList[idx].props.awardMoney}
                                displaySummary={true}
                                summary={itemList[idx].props.summary}
                                verified={itemList[idx].props.verified}
                            >
                                <GrantBookmark
                                    slot="lead"
                                    grant_id={itemList[idx].props.grantId}
                                    user_id={session?.user.id}
                                    {session_id}
                                    doLoad={false}
                                    isChecked={itemList[idx].props.bookmarked}
                                ></GrantBookmark>
                            </GrantCard>
                        </div>
                    {/if}
                {/each}
            {:else}
                {#each { length: 10 } as _, i}
                    <GrantSearchLoadingItem></GrantSearchLoadingItem>
                {/each}
            {/if}
        </div>
    </div>

    <div class="flex justify-center items-center">
        {#if itemList.length}
            <button
                class="rounded-lg transition duration-300 hover:bg-secondary-600"
                on:click={() => {
                    let old_page_num = page_num;
                    page_num = Math.max(0, page_num - 1);
                    if (old_page_num != page_num) {
                        scrollTop();
                    }
                }}
            >
                <img src={ArrowLeft} class="size-8" alt="Previous Page" />
            </button>
            <p class="px-1">Page {page_num + 1} of {Math.ceil((itemList.length * 1.0) / 10)}</p>
            <button
                class="rounded-lg transition duration-300 hover:bg-secondary-600"
                on:click={() => {
                    let old_page_num = page_num;
                    page_num = Math.min(Math.ceil((itemList.length * 1.0) / 10) - 1, page_num + 1);
                    if (old_page_num != page_num) {
                        scrollTop();
                    }
                }}
            >
                <img src={ArrowRight} class="size-8" alt="Next Page" />
            </button>
        {:else}
            <p class="px-1">No Results</p>
        {/if}
    </div>
</div>

<style>
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        transition: background-color 5000s ease-in-out 0s;
        -webkit-text-fill-color: #a4a09b;
        -webkit-text-size-adjust: none;
        font-size: 20px;
        font-family: "Open Sans";
        font-weight: 400;
        font-style: normal;
        line-height: normal;
    }

    input:focus {
        box-shadow: none;
    }

    ::placeholder {
        color: #a4a09b;
        opacity: 1;
        font-size: 20px;
        font-weight: 400;
        font-style: normal;
        line-height: normal;
    }
</style>
